import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDuolingoComponent } from './simple-icons-duolingo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDuolingoComponent ],
    exports:      [ SimpleIconsDuolingoComponent ],
    bootstrap:    []
})
export class SimpleIconsDuolingoModule {}
